/**
 * Created by Ning Jiang on 10/4/2018.
 */

import {Background, IBackgroundConfig} from "@nolimitcity/slot-game/bin/core/background/Background";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {CreepyCarnivalTwoGameAssets} from "../CreepyCarnivalTwoGameAssets";
import {CreepyCarnivalTwoGameConfig} from "../CreepyCarnivalTwoGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {CreepyCarnivalTwoGameModuleConfig} from "../CreepyCarnivalTwoGameModuleConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class CCTwoBackground extends Background {

    private _mobile_logo: PIXI.Sprite;
    private _desktop_logo: PIXI.Sprite;
    private _frame_Bottom: PIXI.Sprite;

    constructor(config: IBackgroundConfig) {
        super(config);
    }

    protected initAnimations(): void {
        super.initAnimations();

        this._frame_Bottom = new PIXI.Sprite(GameResources.getTextures(CreepyCarnivalTwoGameAssets.FRAME_BOTTOM)[0]);

        this.addChild(this._frame_Bottom);
        this._mobile_logo = new PIXI.Sprite(GameResources.getTextures(CreepyCarnivalTwoGameAssets.MOBILE_LOGO)[0]);
        this._mobile_logo.anchor.set(0.5, 0.5);
        this._mobile_logo.scale.set(0.4, 0.4);
        this._mobile_logo.position.set(650, -151);

        this._mobile_logo.alpha = 0;
        this.addChild(this._mobile_logo);
        this._desktop_logo = new PIXI.Sprite(GameResources.getTextures(CreepyCarnivalTwoGameAssets.LOGO)[0]);
        this._desktop_logo.anchor.set(0.5, 0.5);
        this._frame_Bottom.anchor.set(0.5, 0.5);
        this._desktop_logo.position.set(646, 25);
        this._desktop_logo.scale.set(1.01);
        this.addChild(this._desktop_logo);
    }

    protected onResize(resizeData: IResizeData): void {
        if (resizeData.orientation == Orientation.PORTRAIT) {
            this._mobile_logo.alpha = 1;
            this._desktop_logo.alpha = 0;
            CreepyCarnivalTwoGameModuleConfig.background.position.set(-500, -500);
            this._frame_Bottom.scale.set(1);
            this._frame_Bottom.position.set(646, 1253);
            this._mobile_logo.anchor.set(0.5, 0);
            this._mobile_logo.position.set(Helper.getSymbolPositions(8, 0)[0], Helper.getSymbolPositions(1, 0)[0] - 3.7 * CreepyCarnivalTwoGameConfig.instance.SYMBOL_HEIGHT - 20);
        } else {
            this._mobile_logo.alpha = 0;
            this._desktop_logo.alpha = 1;
            CreepyCarnivalTwoGameModuleConfig.background.position.set(-500, -500);
            this._frame_Bottom.scale.set(1.02);
            this._frame_Bottom.position.set(652, 1266);
        }
    }
}